import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";
import ProfileForm from "./ProfileForm";
import { toast } from "react-toastify";
class Profile extends Component {
  state = {
    isModal: false,
    formData: null,
    profiles: [],
    loading: false,
  };

  componentDidMount() {
    this.getProfiles();
  }

  async getProfiles() {
    this.setState({ loading: false });

    const profiles = await axios.get("profiles");

    if (profiles.status === 200) {
      this.setState({ profiles: profiles.data, loading: true });
    }
  }

  showModal = (profile = null) => {
    this.setState({
      isModal: !this.state.isModal,
      formData: profile,
    });

    if (profile === null) this.getProfiles();
  };

  delete = (profileId) => {
    axios
      .delete("profiles/" + profileId)
      .then((response) => {
        this.getProfiles();
        toast(response?.data?.msg, {
          theme: "light",
          style: { backgroundColor: "blue", color: "white" },
        });
      })
      .catch((error) => {
        toast(error.response?.data?.msg, {
          theme: "light",
          style: { backgroundColor: "red", color: "white" },
        });
      });
  };

  handleCheck(val) {
    const permissions = localStorage.getItem("permissions")
      ? JSON.parse(localStorage.getItem("permissions"))
      : [];

    return permissions.some((item) => val === item.permission);
  }

  render() {
    const profiles = this.state.profiles
      .filter((profile) => profile.model === this.props.model)
      .map((profile) => (
        <div className="col-md-6 col-xl-4 mb-3" key={profile.id}>
          <div className="card h-100 border-0 shadow-sm rounded-4">
            <div className="card-body">
              <div className="student-form__heading mb-3">
                <span className="student-form__heading-icon">
                  { profile.profile?.slice(0, 1)}
                </span>

                <div>
                  <span className="student-form__eyebrow">{profile.profile}</span>
                    <span className="badge bg-light text-dark border">
                    <FeatherIcon icon="users" size={12} className="me-1" />
                    {profile.userprofiles?.length || 0} utilisateur(s)
                    </span>
                </div>
              </div>

               

              <p className="small text-muted mb-3">
                Ce profil détermine les accès et les actions autorisées pour les utilisateurs liés avec 
                <span className="badge bg-light text-dark border">
                  <FeatherIcon icon="key" size={12} className="me-1" />
                  {profile.profilepermissions?.length || 0} permission(s)
                </span>
              </p>

              <div className="d-flex justify-content-end gap-2">
                {this.handleCheck("Modifier profil") && (
                  <button
                    type="button"
                    className="btn btn-light student-form__button"
                    onClick={() => this.showModal(profile)}
                  >
                    <FeatherIcon icon="edit-3" size={15} /> Modifier
                  </button>
                )}

                {this.handleCheck("Supprimer profil") && (
                  <button
                    type="button"
                    className="btn btn-light text-danger student-form__button"
                    onClick={() => this.delete(profile.id)}
                  >
                    <FeatherIcon icon="trash-2" size={15} /> Supprimer
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ));

    return (
      <div className="col-12">
        <div className="card shadow-sm bg-white mb-2 border-0 rounded-4">
          <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
            <div className="student-form__heading">
              <span className="student-form__heading-icon">
                <FeatherIcon icon="shield" size="20" />
              </span>

              <div>
                <span className="student-form__eyebrow">Gestion des accès</span>
                <h6 className="mb-0">Profils utilisateurs</h6>
              </div>
            </div>

            {this.handleCheck("Afficher profil") && (
              <button
                type="button"
                className="btn btn-primary student-form__button"
                onClick={() => this.showModal(null)}
              >
                <FeatherIcon icon="plus" size={16} /> Nouveau profil
              </button>
            )}
          </div>

          <div className="card-body">
            <div className="row">
              {profiles.length > 0 ? (
                profiles
              ) : (
                <div className="col-12">
                  <div className="student-form__alert">
                    <FeatherIcon icon="info" size={17} />
                    <span>Aucun profil trouvé pour ce module.</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <ProfileForm
          isModal={this.state.isModal}
          formData={this.state.formData}
          showModal={this.showModal}
          model={this.props.model}
        />
      </div>
    );
  }
}

export default Profile;